import type { ProductTaxonomyRenameDefinition } from '../types';

export const broadcastsRename = {
  copy: {
    'nav.broadcasts.newsletters': {
      current: 'Newsletters',
      future: 'One-time sends',
    },
    'nav.broadcasts.apiTriggered': {
      current: 'API-triggered',
      future: 'API-triggered workflow',
    },
  },
  routes: {
    'broadcasts.oneTimeSends': {
      current: '/workspaces/:workspaceId/journeys/broadcasts/newsletters',
      future: '/workspaces/:workspaceId/journeys/broadcasts/one_time_sends',
    },
    'broadcasts.apiTriggered': {
      current: '/workspaces/:workspaceId/journeys/broadcasts/api-triggered',
      future: '/workspaces/:workspaceId/journeys/broadcasts/api-triggered',
    },
  },
} as const satisfies ProductTaxonomyRenameDefinition;
